module.exports = __webpack_public_path__ + "img/404.7650cda6.svg";